import axios from 'axios'
import merge from 'lodash/merge'

import { APP_TOKEN_KEY, MULTIPART_FORM_CONFIG } from '../constants'
import { saveValue } from '../localStorage'
import { $post } from './http-client'

const instance = axios.create({
  baseURL: process.env.API_SERVICE_HOST,
})

const generateRandomString = (length) => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~'
  let result = ''
  const charactersLength = characters.length
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

const base64UrlEncode = (str) => {
  return btoa(String.fromCharCode(...new Uint8Array(str)))
    .replace(/=/g, '')
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
}

const sha256 = async (message) => {
  const encoder = new TextEncoder()
  const data = encoder.encode(message)
  const hash = await crypto.subtle.digest('SHA-256', data)
  return hash
}

const generateCodeChallenge = async (codeVerifier) => {
  const hashed = await sha256(codeVerifier)
  return base64UrlEncode(hashed)
}

const CODE_VERIFIER_LENGTH = 128;

export const $requestToken = async () => {
  try {
    const redirectUri = `${process.env.TOKEN_REDIRECT_HOST}/${APP_CODE}/callback`
    const codeVerifier = generateRandomString(CODE_VERIFIER_LENGTH)
    const codeChallenge = await generateCodeChallenge(codeVerifier)
    const res = await instance.get('/authorization/oauth/authorize', {
      params: {
        redirect_uri: redirectUri,
        response_type: 'code',
        scope: 'read',
        code_challenge: codeChallenge,
        code_challenge_method: 'S256',
        response_mode: 'query',
      },
    })

    if (!res.data) {
      throw new Error('Cannot request token!')
    }

    const url = '/authorization/oauth/token'
    const formData = new FormData()
    formData.append('grant_type', 'authorization_code')
    formData.append('redirect_uri', redirectUri)
    formData.append('code', res.data.code)
    formData.append('code_verifier', codeVerifier)

    const tokenResponse = await instance.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    if (!tokenResponse.data) {
      throw new Error('Cannot request token!')
    }

    saveValue(APP_TOKEN_KEY, tokenResponse.data.access_token)
    return tokenResponse.data
  } catch (error) {
    console.log(error)
  }
}

export const $getIJoistManufacturer = async (member, body = {}) => {
  try {
    const response = await $post(`/api/JoistSelector/Get${member}ManufacturerProducts`, body)

    if (response.data) {
      const formattedResponse = response.data.reduce((prev, cur) => {
        const { manufacturer, series, product } = cur

        return merge(prev, { [manufacturer]: { [series]: { [product]: cur } } })
      }, {})

      return formattedResponse
    } else return []
  } catch (error) {
    throw new Error(error)
  }
}

export const $submitFormToSmartSheet = async (body, appId) => {
  try {
    const response = await $post(`/smartsheet/v2/?app-id=${appId}`, body, MULTIPART_FORM_CONFIG)

    return response.data
  } catch (error) {
    throw new Error(error)
  }
}

export * from './http-client'
